<template>
  <div class="row ">
    <div class="flex xs12">
      <va-modal v-model="showUpdateReportModal" overlay-opacity="0.2" size="medium" hide-default-actions blur>
        <template #header>
          <h2>Update Report</h2>
        </template>
        <EditReportModal :title="Edit" :propsId=updateReport.id :propsReportId=updateReport.report_id
          :propsName=updateReport.name :propsWorkspaceId=updateReport.workspace_id
          :propsPermissionId=updateReport.permission_id :propsCategoryId=updateReport.category_id
          :propsEnableRLS=updateReport.enable_RLS @close="close" />
      </va-modal>
      <va-tabs center v-model="activeTab" style="width: 100%; min-width: 300px" class="flex pad1" :hide-slider="true">
        <template #tabs>
          <va-tab color="#5DABDF" name="ReportManagementTab">
            Report management
          </va-tab>
          <va-tab color="#5DABDF" name="ExportManagementTab">
            Export management
          </va-tab>
          <va-tab color="#5DABDF" name="DownloadManagementTab">
            Download management
          </va-tab>
          <va-tab color="#5DABDF" name="EntityManagementTab">
            Entity management
          </va-tab>
          <va-tab color="#5DABDF" name="SuperUserInviteTab">
            Special user management
          </va-tab>
          <va-tab color="#5DABDF" name="DomainWhitelistTab">
            Domain whitelist
          </va-tab>
        </template>
      </va-tabs>
      <!-- Display the component based on the activeTab selected above. Manual override instead of using <component :is /> logic-->
      <!-- <component :is="activeTab" @submit="submit" /> -->
      <ReportManagementTab @openEditReportModal="openEditReportModal" @removeReport="removeReport"
        v-if="activeTab === 'ReportManagementTab'" />
      <ExportManagementTab v-if="activeTab === 'ExportManagementTab'" />
      <DownloadManagementTab v-if="activeTab === 'DownloadManagementTab'" />
      <EntityManagementTab v-if="activeTab === 'EntityManagementTab'" />
      <SuperUserInviteTab v-if="activeTab === 'SuperUserInviteTab'" />
      <DomainWhitelistTab v-if="activeTab === 'DomainWhitelistTab'" />
    </div>
  </div>
</template>

<script>
import DownloadManagementTab from './DownloadManagementTab';
import ExportManagementTab from './ExportManagementTab';
import ReportManagementTab from './ReportManagementTab';
import EntityManagementTab from './EntityManagementTab';
import SuperUserInviteTab from './SuperUserInviteTab';
import DomainWhitelistTab from './DomainWhitelistTab';
import EditReportModal from '@/modules/admin/components/EditReportModal'
import { mapState, mapActions } from "vuex";

// import SchoolSelection from '@/modules/benchmark-report/components/school-selection'
// import AIGeneratedTab from '@/modules/benchmark-report/components/benchmark-tabs/AIGeneratedTab';
export default {
  name: 'Super User Management',
  components: {
    ReportManagementTab, EntityManagementTab, SuperUserInviteTab, DownloadManagementTab, ExportManagementTab, EditReportModal, DomainWhitelistTab
  },
  data() {
    return {
      activeTab: 'ReportManagementTab',
      showUpdateReportModal: false,
      updateReport: null
    };
  },
  methods: {
    ...mapActions({
      deleteReport: "admin/deleteReport"
    }),
    openEditReportModal(modalInfo) {
      this.showUpdateReportModal = !this.showUpdateReportModal;
      this.updateReport = modalInfo.report;
    },
    close() {
      this.showUpdateReportModal = false
    },
    removeReport(param) {
      this.deleteReport(param.report)
        .then(() => {
          if (this.selectedEntity) {
            this.getReportList(this.selectedEntity.id)
          }
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.reportManagementContainer {
  display: flex;
}

.entityManagementContainer {
  display: flex;
}

.superUserInviteContainer {
  display: flex;
}
</style>